<div *ngIf="reportType === 'InDetail'">
  <div id="print-section">

    <!-- ================= HEADER TABLE (PRINT ONCE) ================= -->
    <table id="header-table" style="width:100%;border-collapse:collapse;border:1px solid black;">
      <tr style="font-size: 18px; font-weight: bold;">
        <th colspan="10" style="border:1px solid black; text-align:center; padding:6px; font-size: 18px; background-color: #f1f1f1;">
          हिंदुस्तान प्रकाशन संस्था 
        </th>
        <th colspan="10" style="border:1px solid black; text-align:center; padding:6px; font-weight:bold; font-size: 18px; background-color: #f1f1f1;">
          Book Registration Ledger Report
        </th>
        <th colspan="10" style="border:1px solid black; text-align:right; padding:6px; font-size: 18px; background-color: #f1f1f1;">
          दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
        </th>
      </tr>

      <tr style="font-size: 18px; font-weight: bold;">
        <th colspan="10" style="border:1px solid black; padding:6px; text-align:center; font-size: 16px; font-weight: bold; background-color: #f1f1f1;">
          विवेक पुस्तक प्रकाशन
        </th>
        <th colspan="10" style="border:1px solid black; padding:6px; font-size: 16px; font-weight: bold; background-color: #f1f1f1;text-align:center;">In Detail</th>
        <th colspan="10" style="border:1px solid black; padding:6px; text-align:right; font-size: 16px; font-weight: bold; background-color: #f1f1f1;">
          Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>
    </table>

    <!-- ================= DATA TABLE (COLUMN HEADERS REPEAT) ================= -->
    <table id="data-table" style="width:100%;border-collapse:collapse;border:1px solid black;font-size:13px;">
      <thead>
        <tr>
          <th style="border:1px solid black;">Sr</th>
          <th style="border:1px solid black;">Order Date</th>
          <th style="border:1px solid black;">Order No</th>
          <th style="border:1px solid black;width:4%;text-align:left;">Book Seller Name</th>
          <th style="border:1px solid black;text-align:left;">District</th>
          <th style="border:1px solid black;">Mobile No</th>
          <th style="border:1px solid black;text-align:left;">Rep Name</th>
          <th style="border:1px solid black;text-align:left;">Office Rep</th>
          <th style="border:1px solid black;width:6%;text-align:left;">Book Name</th>
          <th style="border:1px solid black;text-align:right;">Sale<br>Copy </th>
          <th style="border:1px solid black;text-align:right;">Return<br>Copy </th>
          <th style="border:1px solid black;text-align:right;">Comp<br>Copy</th>
          <th style="border:1px solid black;text-align:right;">Book Price</th>
          <th style="border:1px solid black;text-align:right;">Sale Price</th>
          <th style="border:1px solid black;text-align:right;">Net Amt</th>
          <th style="border:1px solid black;text-align:right;">Shipping </th>
          <th style="border:1px solid black;text-align:right;">Total Amt</th>
          <th style="border:1px solid black;text-align:right;">Received<br>Amt</th>
          <th style="border:1px solid black;text-align:right;">Credit<br>Amt</th>
          <th style="border:1px solid black;text-align:right;">Pending<br>Amt</th>
          <th style="border:1px solid black;">Invoice No</th>
          <th style="border:1px solid black;text-align:right;">Rep<br>Commission<br>Amt</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let d of filterData; let i = index">
          <td style="border:1px solid black;">{{ i + 1 }}</td>
          <td style="border:1px solid black;">{{ d.booking_date | date:'dd-MM-yyyy' }}</td>
          <td style="border:1px solid black;">{{ d.oder_no || '-' }}</td>
          <td style="border:1px solid black;">{{ d.book_seller_name || '-' }}</td>
          <td style="border:1px solid black;">{{ d.district || '-' }}</td>
          <td style="border:1px solid black;">{{ d.mobile_no || '-' }}</td>
          <td style="border:1px solid black;">{{ d.rep_name || '-' }}</td>
          <td style="border:1px solid black;">{{ d.office_rep_name || '-' }}</td>
          <td style="border:1px solid black;">{{ d.book_name || '-' }}</td>  
          <td class="text-end" style="border:1px solid black;">{{ d.sale_copies }}</td>
          <td class="text-end" style="border:1px solid black;">{{ d.return_copies }}</td>
          <td class="text-end" style="border:1px solid black;">{{ d.complimentary_copies }}</td>
          <td class="text-end" style="border:1px solid black;">{{ d.book_price  }}</td>
          <td class="text-end" style="border:1px solid black;">{{ d.sale_price  }}</td>
          <td class="text-end" style="border:1px solid black;">{{ d.total  }}</td>
          <td class="text-end" style="border:1px solid black;">{{ d.shipping_charges  }}</td>
          <td class="text-end" style="border:1px solid black;">{{ d.totalAmount  }}</td>
          <td class="text-end" style="border:1px solid black;">{{ d.received_amt }}</td>
          <td class="text-end" style="border:1px solid black;">{{ d.credit_amt }}</td>
          <td class="text-end" style="border:1px solid black;">{{ d.remaining_amt  }}</td>
          <td style="border:1px solid black;">{{ d.invoice_no || '-' }}</td>
          <td class="text-end" style="border:1px solid black;">{{ d.rep_commission_amt  }}</td>
        </tr>

        <tr *ngIf="filterData.length === 0">
          <td colspan="22" style="text-align:center;font-weight:bold;border:1px solid black;">
            No records found
          </td>
        </tr>
      </tbody>

      <!-- ================= TOTAL (MOVED TO TFOOT) ================= -->

        <tr style="background:#c8753f;font-weight:bold;color:white;">
          <td colspan="9" style="text-align:right;border:1px solid black;">Grand Total</td>
          <td class="text-end" style="border:1px solid black;">{{ TotalSaleCopies }}</td>
          <td class="text-end" style="border:1px solid black;">{{ TotalReturnCopies }}</td>
          <td class="text-end" style="border:1px solid black;">{{ TotalComplimentary }}</td>
          <td style="border:1px solid black;"></td>
          <td style="border:1px solid black;"></td>
          <td class="text-end" style="border:1px solid black;">₹{{ TotalNetAmount }}</td>
          <td class="text-end" style="border:1px solid black;">₹{{ TotalShippingCharges  }}</td>
          <td class="text-end" style="border:1px solid black;">₹{{ TotalAmount }}</td>
          <td class="text-end" style="border:1px solid black;">₹{{ TotalReceipt  }}</td>
          <td class="text-end" style="border:1px solid black;">₹{{ TotalCredit  }}</td>
          <td class="text-end" style="border:1px solid black;">₹{{ TotalPending  }}</td>
          <td style="border:1px solid black;"></td>
          <td class="text-end" style="border:1px solid black;">₹{{ TotalCommission  }}</td>
        </tr>
    
    </table>
  </div>

  <!-- ================= BUTTONS ================= -->
  <div class="noPrint text-end mt-3">
    <button class="btn btn-primary me-2" (click)="exportExcel('Book_Registration_Ledger')">
      Export
    </button>
    <button class="btn btn-primary me-2" (click)="printPage4()">
      Print
    </button>
    <button class="btn btn-secondary" mat-dialog-close>
      Close
    </button>
  </div>
</div>